<template>
    <div id="app">
      <el-container class="container">
        <el-aside width="sideWidth+'px'"> <!--width="sideWidth+'px'"导航栏动态宽度-->
          <el-menu  style="min-height: 100%" active-text-color="#fff"  background-color="#0889FD"
                    unique-opened
                  text-color="#fff"
                  :collapse-transition="false"
                  :collapse="isCollapse"
                  :default-active="this.$route.path"
                  class="custom-menu"
                  :router="true"
          >
            <div style="height: 75px; line-height: 75px; text-align: center">
              <!-- <img src="../assets/logo.png" alt="" style="width: 30px;position: relative; top: 10px;margin-right: 10px"> -->
              <b style="color: #fff;font-size: 24px;padding: 30px;" v-show="logoTextShow">纽康易选</b>
            </div>
            <!-- 循环生成菜单项 -->
             <div style="margin-left: 22px;" @click="handleItemClick()">
                <template v-for="item in menuList" >
                  <!-- 如果有子菜单，则生成子菜单 -->
                  <el-submenu :index="item.index" v-if="item.children && item.children.length > 0" :key="item.index">
                    <template slot="title">
                      <i :class="item.icon"></i>
                      <span slot="title">{{ item.title }}</span>
                    </template>
                    <!-- 生成子菜单项 -->
                    <el-menu-item v-for="subItem in item.children" :index="subItem.path" :key="subItem.index" >
                      <span slot="title" style="display: inline-block;margin-left: 0px;text-align: center;">{{ subItem.title }}</span>
                    </el-menu-item>
                  </el-submenu>
                  <!-- 如果没有子菜单，则生成一级菜单 -->
                  <el-menu-item :index="item.path" v-else :key="item.icon">
                    <i  :class="item.icon"></i>
                    <span slot="title">{{ item.title }}</span>
                  </el-menu-item>
                </template>
             </div>
              <!-- <img src="../assets/logo.png" alt="" style="width: 122px;height: 95px;position: absolute;bottom: 24px;left: 40px;"> -->
          </el-menu>
        </el-aside>
      <el-container>
          <el-header style="font-size: 12px;height: 75px; line-height: 75px;display:flex;background: #fff;border-radius: 60px 0 0 0;">
              <div style="flex: 1; font-size: 25px;display: flex;align-items: center;">
                  <span :class="collapseBtnClass" style="cursor: pointer;margin-right: 20px;" @click="collapse"></span>
                  <img src="../assets/logo6.png" alt="">
                </div>
                <div class="tixing" ref="popoverWrapper">
                  <el-popover
                    ref="popover"
                    placement="bottom"
                    width="260"
                    v-model="visible"
                    trigger="manual"
                    class="custom-popover"
                    >
                    <div class="syddklb">
                      <div class="notextList" v-if="messageChatVos.length <= 0">暂无数据!</div>
                      <ul  class="syddklbul" v-for="item in messageChatVos" :key="item.orderId">
                        <li class="syddklbli" @click="syddklbtzxq(item.orderId)">{{ item.messageContent }}</li>
                      </ul>
                      <p style="cursor: pointer; margin: 0; margin-top: 20px;" @click="syddklbckqb">查看全部</p>
                    </div>
                  </el-popover>
                  <img v-if="unReadMessageCount>0"  @click="openPopover" style="cursor: pointer;"  src="../assets/tixing.png" alt="" >
                  <img v-else  src="../assets/tixing.png" alt="" >
                  <span v-if="unReadMessageCount<100">{{ unReadMessageCount }}</span>
                  <span v-else>99+</span>
                </div>
                <div class="personnel">
                      <img class="ims" src="../assets/toux.png" alt="" >
                      <el-dropdown class="exityh">
                        <span style="color:#000">
                          <span>当前用户：{{ username }}</span>
                          <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item command="logout" @click.native="returns">退出</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                </div>
                <!-- <el-dropdown style="width: 100px;cursor:pointer;color: aqua;">
                  <span>{{username}}</span>
                  <i class="el-icon-arrow-down" style="margin-left: 5px"></i>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>个人信息</el-dropdown-item>
                    <el-dropdown-item>退出</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown> -->
          </el-header>
          <el-main >
            <router-view></router-view>
          </el-main>
        </el-container>
      </el-container>
  </div>
</template>

<script>
export default {
    name: 'navigation',
    data() {
        return {
          visible: false,
          collapseBtnClass:'el-icon-s-fold',
          isCollapse:false,
          sideWidth:200, //动态收缩导航栏初始值200
          logoTextShow:true,
          username:'',
          messageChatVos: [{
              messageContent: '202502111321118936587002',
              orderId:'1889182877166370817'
          }],
          unReadMessageCount:null,
            menuList: [
              // {
              //   icon: 'el-icon-eleme',
              //   index: '1',
              //   title: '数据中心',
              //   path: '/datacenter',
              // },
              //   {
              //     icon: 'el-icon-house',
              //     index: '2',
              //     title: '工单管理',
              //     path: '/jlWorkrder',
              //     children: [
              //       {
              //         index: '1-1',
              //         title: '工单记录',
              //         path: '/jlWorkrder',
              //       },
              //       {
              //         index: '1-2',
              //         title: '流程配置',
              //         path: '/Configuration',
              //       },
              //       {
              //         index: '1-3',
              //         title: '工单维护',
              //         path: '/maintenance',
              //       },
              //       {
              //         index: '1-4',
              //         title: '超时工单',
              //         path: '/timeout',
              //       },
              //       {
              //         index: '1-5',
              //         title: '待分配工单',
              //         path: '/allocated',
              //       }
              //     ]
              // },
            
              // {
              //   icon: 'el-icon-s-tools',
              //   index: '4',
              //   title: '维修零件',
              //   path: '/wxpart',
              // },
              // {
              //   icon: 'el-icon-s-promotion',
              //   index: '5',
              //   title: '产品管理',
              //   path: '/cpproduct',
              // },
            ],
          }
    },
    created(){
      this.username = sessionStorage.getItem("username")
    },
    mounted() {
      this.getlist2()
      this.wdxxslist()
      document.addEventListener("click", this.handleClickOutside);
    },
    beforeDestroy() {
      document.removeEventListener("click", this.handleClickOutside);
    },
    computed:{
     
    },
    methods: {
      collapse(){
      this.isCollapse = !this.isCollapse
      if (this.isCollapse){
        this.sideWidth = 64
        this.collapseBtnClass='el-icon-s-unfold'
        this.logoTextShow=false
      }else {  
        this.sideWidth = 200
        this.collapseBtnClass='el-icon-s-fold'
        this.logoTextShow=true
      }
      },
      handleItemClick(){
        this.wdxxslist()
      },
      wdxxslist(){
        this.$api.selectUnReadMessage().then((res) => {
               if(res.data.code==200){
                  let data = res.data.data
                  this.unReadMessageCount= data.unReadMessageCount
                  this.messageChatVos = data.messageChatVos
               }else{
                  this.$message.error(res.data.message)
               }
         })
      },
      handleClickOutside(event) {
        if (this.$refs.popoverWrapper && !this.$refs.popoverWrapper.contains(event.target)) {
          this.visible = false;
        }
      },
      openPopover() {
        this.visible = true;
        this.wdxxslist()
      },
      syddklbtzxq(orderId){
        console.log(1111111111111);
        this.$router.push({
            path: "cpproductorderdetail",
            query: {
              orderId: orderId,
            },
         });
         this.visible = false;
      },
      syddklbckqb(){
        this.$router.push({
            path: "cpproductorder",
         });
         this.visible = false;
      },
      getlist2(){
        this.$api.leftResource().then((res) => {
          let datalist = []
          let permissList= []
          let cpgldatalist = []
          let yxhddatalist = []
          let xtszdatalist = []
          res.data.data.forEach(e=>{
            e.resourceVoList.forEach(item => {
              permissList.push(item.resourceName)
            });
            let data = {
              icon:e.icon,
              title:e.resourceName,
              index:`${e.id}`,
              path: '',
            }
            datalist.push(data)
            if (e.resourceName == '产品管理') {
              e.resourceVoList.forEach(element => {
                let datainfo = {
                  title:element.resourceName,
                  index:`${element.id}`,
                  path: '',
                }
                cpgldatalist.push(datainfo)
              });
            }else if (e.resourceName == '营销活动') {
              e.resourceVoList.forEach(element => {
                let datainfo = {
                  title:element.resourceName,
                  index:`${element.id}`,
                  path: '',
                }
                yxhddatalist.push(datainfo)
              });
            }else if (e.resourceName == '系统管理') {
              e.resourceVoList.forEach(element => {
                let datainfo = {
                  title:element.resourceName,
                  index:`${element.id}`,
                  path: '',
                }
                xtszdatalist.push(datainfo)
              });
            }
          })
          datalist = datalist.map(item => {
            if (item.title === "产品管理") {
              return { ...item, children: cpgldatalist };
            }else if (item.title === "营销活动") {
              return { ...item, children: yxhddatalist };
            }else if (item.title === "系统管理") {
              return { ...item, children: xtszdatalist };
            }
            return item;
          });
          datalist.forEach(ele => {
            if (ele.title == "数据中心") {
              ele.icon = 'el-icon-alishuju'
              ele.path = '/datacenter'
            }else if (ele.title == "产品管理") {
              ele.icon = 'el-icon-alishangpin'
              ele.children.forEach(elemen => {
                if (elemen.title == "产品列表") {
                  elemen.path = '/productlist'
                }
                else if (elemen.title == "分类管理") {
                  elemen.path = '/classification'
                }
                else if (elemen.title == "下架产品") {
                  elemen.path = '/removefrom'
                }
                else if (elemen.title == "规格配置") {
                  elemen.path = '/specifications'
                }
                else if (elemen.title == "配件库") {
                  elemen.path = '/accessories'
                }
              });
            }else if (ele.title == "订单管理") {
              ele.icon = 'el-icon-alidingdan'
              ele.path = '/cpproductorder'
            }else if (ele.title == "营销活动") {
              ele.icon = 'el-icon-aliyingxiaohuodong'
              ele.children.forEach(elemen => {
                if (elemen.title == "公告管理") {
                  elemen.path = '/noticegl'
                }
                else if (elemen.title == "海报管理") {
                  elemen.path = '/postergl'
                }
                else if (elemen.title == "引导语设置") {
                  elemen.path = '/language'
                }
                else if (elemen.title == "轮播图设置") {
                  elemen.path = '/carouselsz'
                }
              });
            }else if (ele.title == "系统管理") {
              ele.icon = 'el-icon-alishezhi'
              ele.children.forEach(elemen => {
                if (elemen.title == "白名单") {
                  elemen.path = '/xtglwxpart'
                }
                else if (elemen.title == "用户管理") {
                  elemen.path = '/userwxpart'
                }
                else if (elemen.title == "角色管理") {
                  elemen.path = '/rolewxpart'
                }
                else if (elemen.title == "来访记录") {
                  elemen.path = '/lfcometovisit'
                }
                else if (elemen.title == "区域经理") {
                  elemen.path = '/qymanager'
                }
              });
            }
          });
          this.menuList = datalist
        })
      },
      returns() {
          this.$cookies.remove('token')
          this.$cookies.remove("saTokenInfo")
          this.$router.push({ path: '/' });
      },
      },
    }
</script>

<style  scoped>
.el-container
.container{
  height: 100vh
}
.custom-menu .el-menu-item i {
  color: white; /* 默认白色背景 */
}
.custom-menu .el-submenu__title i {
    color: #fff;
    margin-left: 0 !important;
}
.custom-menu /deep/ .el-submenu__icon-arrow{
  color: #fff !important;
}
.el-menu--collapse /deep/ .el-submenu__icon-arrow{
  display: none; /* 隐藏折叠图标 */
}
.custom-menu .el-menu-item.is-active i{
  color: #0889FD !important;
}
.el-container{
  min-height: 100vh;
  background-color: #0889FD;
}
.el-aside{
  overflow: hidden;
}
.container /deep/ .el-submenu .el-menu-item{
  min-width: 125px !important;
  height: 45px !important;
  line-height: 45px;
  
}
.container /deep/ .el-menu-item i {
  margin-left: -10px;
}
.container /deep/ .el-menu{
  border-right: solid 0px #e6e6e6
}
.container /deep/  .el-menu-item.is-active {
  width: 125px;
  height: 45px;
  line-height: 45px;
  border-radius: 8px;
  color: #0889FD !important;
  background-color: #fff !important;

}
.container /deep/ .el-submenu__title{
  padding-left: 10px !important;
}
.container /deep/ .el-submenu.is-active .el-submenu__title {
    padding-left: 10px !important;
}
.menu-icon {
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: #409eff !important;
  border-radius: 2px;
  margin-right: 8px;
  vertical-align: middle;
}
.personnel{
    position: absolute;
    right: 0;
    width: 300px;
  }
  .personnel img{
    height: 50px;
    border-radius: 100%;
    vertical-align: middle;
  }
  .personnel p:nth-child(2){
    font-size: 26px;
    color: #fff;
    margin: 0;
    padding: 10px 0 0 10px;
  }
  .exityh{
    display: inline-block;
    vertical-align: middle;
    font-size: 16px;
    margin: 12px 0 0 10px;
    height: 50px;
    line-height: 50px;
  }
  .tixing{
    position:relative;
    right: 300px;
    line-height: 100px;
  }
  .tixing img{
    width: 42px;
    height: 38px;
    margin-right: 50px;
  }
  .tixing span{
    width: 20px;
    height: 20px;
    position: absolute;
    right: 50px;
    top: 16px;
    display: inline-block;       
    background-color: red;     
    color: white;     
    border-radius: 50%;
    text-align: center;
    line-height: 20px; 
  }
  .custom-popover /deep/ .el-popper {
    margin-top: 50px; /* 手动设置偏移 */
    margin-left: -150px; /* 手动设置位置 */
    box-shadow: 0 6px 22px 0 rgba(0,0,0,0.4);
  }
  .syddklb{
    text-align: center;
  }
  .syddklb /deep/ .syddklbul,.syddklbli {
    margin: 0;
    padding: 5px;
    line-height: 1;
    outline: none;
    overflow: hidden; 
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer
  }
  .syddklb /deep/ .syddklbul{
    border-bottom: 1px solid #F0F0F0;
    padding-bottom: 15px;
  }
  .syddklb p{
    color: #0889FD;
  }
  .notextList {
    text-align: center;
    margin-top: 15px;
    font-size: 16px !important;
    padding-bottom: 10px;
    color: #aaa;
  }
  .syddklbul li:hover{
    color: #409eff;
  }
</style>


// WEBPACK FOOTER //
// src/components/navigation.vue